import {getFieldValue, clearFieldValue} from '../../controllers/events/custom';
import {resetRender} from '../../controllers/events/render';
import {settings} from '../../common/setting';
import {user} from '../../controllers/user';
import {customFormService} from '../../services/customForm';
import {cr} from 'fire-wind-water';
import {addClass, removeClass} from 'fire-wind-water/dom';

function save(t){
  t.disabled = false;
  const result = getFieldValue();
  const info = {
    customFormId: settings.customFormId,
    globalUserId: user.globalUserId,
    instanceId: settings.instanceId,
    items: result.field,
    linkId: '',
    openId: '',
    referenceUrl: '',
    signPointItems: [],
    tenantId: settings.tenantId,
    url: window.location.href,
    ver: 'v2.0.1',
    channel_code: settings.channel_code,
    siteId: settings.siteId,
    memberId: user.memberId,
    sess: user.session
  };
  if (result.verificationCode) {
    info.verificationCode = result.verificationCode;
  }
  if (result.scenesKey) {
    info.scenesKey = result.scenesKey;
  }
  if (cr.isArray(info.customFormId)) {
    info.customFormId = info.customFormId[0];
  }
  if (!result.isVerify) {
    return;
  }
  if (settings.isPreview) {
    $s_temp.alert('当前页面为预览页面，不能提交');
    return;
  }
  t.disabled = true;
  addClass(t, 'disabled');
  customFormService.action(info, (res) => {
    if (res.result == 0) {
      window.scroll(0, 0);
      clearFieldValue();
      resetRender(true);
      $s_temp.alert('提交成功');
    } else {
      $s_temp.alert(res.desc);
    }
    t.disabled = false;
    removeClass(t, 'disabled');
  });
}
export function customSave(t) {
  if (t.disabled) {
    return;
  }
  t.disabled = true;
  save(t);
}